var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialDeleteForever(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.682,
    height: 20.163,
    viewBox: "0 0 15.682 20.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M8.62,22.423a2.247,2.247,0,0,0,2.24,2.24h8.961a2.247,2.247,0,0,0,2.24-2.24V8.981H8.62Zm2.756-7.976,1.579-1.579,2.386,2.375,2.375-2.375L19.3,14.447l-2.375,2.375L19.3,19.2l-1.579,1.579L15.341,18.4l-2.375,2.375L11.387,19.2l2.375-2.375ZM19.262,5.62,18.141,4.5h-5.6l-1.12,1.12H7.5V7.86H23.182V5.62Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#5f5959",
    opacity: 0.649
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialDeleteForever);
export default __webpack_public_path__ + "static/media/material-delete-forever.9f5520e5f91ccceca018a3ba0fc5a528.svg";
export { ForwardRef as ReactComponent };